import { BrowserRouter, Routes, Route, useLocation } from "react-router";
import { useEffect } from "react";
import { ShopLayout } from "./components/ShopLayout.tsx";
import { HomePage } from "./pages/HomePage.tsx";
import { ProductPage } from "./pages/ProductPage.tsx";
import { CategoryPage } from "./pages/CategoryPage.tsx";
import { AboutPage } from "./pages/AboutPage.tsx";
import { ContactPage } from "./pages/ContactPage.tsx";
import { PrivacyPage } from "./pages/PrivacyPage.tsx";
import { TermsPage } from "./pages/TermsPage.tsx";
import { WishlistPage } from "./pages/WishlistPage.tsx";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<ShopLayout />}>
          <Route index element={<HomePage />} />
          <Route path="product/:slug" element={<ProductPage />} />
          <Route path="collection/:category" element={<CategoryPage />} />
          <Route path="wishlist" element={<WishlistPage />} />
          <Route path="about-us" element={<AboutPage />} />
          <Route path="contact-us" element={<ContactPage />} />
          <Route path="privacy-policy" element={<PrivacyPage />} />
          <Route path="terms-of-service" element={<TermsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
